/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { Observable } from 'rxjs';
import {
  QuickAnswers,
  QuickAnswersGroups,
  QuickAnswersRequest,
  QuickAnswersType,
} from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class AnswersService {
  private url: string = 'quick-responses/groups';

  constructor(private apiService: ApiService) {}

  public getQuickAnswers(): Observable<QuickAnswers[]> {
    return this.apiService.get(`${this.url}`);
  }

  public getQuickAnswerById(id: number): Observable<QuickAnswersGroups[]> {
    return this.apiService.get(`${this.url}/${id}/messages`);
  }

  public createQuickAnswers(
    request: QuickAnswersRequest,
    id: number,
  ): Observable<any> {
    return this.apiService.post(`${this.url}/${id}/messages`, request);
  }

  public updateQuickAnswers(
    request: QuickAnswersRequest,
    type: QuickAnswersType,
  ): Observable<any> {
    return this.apiService.put(
      `${this.url}/${type.group}/messages/${type.id}`,
      request,
    );
  }

  public deleteQuickAnswers(group: number, id: string): Observable<any> {
    return this.apiService.delete(`${this.url}/${group}/messages/${id}`);
  }
}
